import InventaireStockForm from './inventaire.stock.form.model';

export default class InventaireStockFormController {
	static $inject = [
		'$scope',
		'$state',
		'$stateParams',
		'$translate',
		'ModalService',
		'StocksService',
		'StocksCommunicationService',
		'notification',
		'_',
		'moment',
		'$uibModal',
		'StocksCloturesService'
	];

	constructor(
		$scope,
		$state,
		$stateParams,
		$translate,
		ModalService,
		StocksService,
		StocksCommunicationService,
		notification,
		_,
		moment,
		$uibModal,
		StocksCloturesService
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.params = $stateParams;
		this.$translate = $translate;
		this.ModalService = ModalService;
		this.StocksService = StocksService;
		this.StocksCommunicationService = StocksCommunicationService;
		this.notification = notification;
		this._ = _;
		this.moment = moment;
		this.$uibModal = $uibModal;
		this.StocksCloturesService = StocksCloturesService;

		this.isEditMode = false;
		this.loading = false;
		this.listeEltsNiv1 = [];
		this.regroupementSites = [];
		this.isValidationDisabled = true;

		this.closeAllOnglets();
	}

	async $onInit() {
		if (this.params && this.params.id) {
			this.isEditMode = true;
		}
		await this.loadSocietes();
		this.openFirstOnglet();

		this.ongletOpen = {
			isEnteteOpen: true,
			isInventaireStocksOpen: false,
			isInventaireStocksHistoriqueOpen: false
		};

		await this.initInventaire();
		if (this.isEditMode == false) {
			this.inventaire.idSociete = this.societes[0].id;
			await this.getEltsNiv1();
			await this.loadGroupementSites();
			this.inventaire.idGroupeSite = this.regroupementSites[0].id;
		} else {
			await this.loadGroupementSites();
			await this.loadInventaireStockProduits(
				this.inventaire.idGroupeSite,
				this.inventaire.eltNiv1,
				this.inventaire.idInventaire,
				this.inventaire.dateLevee,
				this.inventaire.isClotured
			);
		}

		this.$scope.$watch(
			() => this.inventaire.idSociete,
			async (newValue, oldValue) => {
				if (newValue === oldValue) return;
				await this.loadGroupementSites();
			},
			true
		);
	}

	async loadSocietes() {
		this.startLoading();
		try {
			this.societes = await this.StocksService.getSocietes();
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async loadGroupementSites() {
		this.startLoading();
		try {
			this.regroupementSites = await this.StocksService.getRegroupementsSite(this.inventaire.idSociete);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async generer() {
		let dateError = false;
		await this.checkDateCloture();
		if (this.derniereCloture != null) {
			var dateClotureMoment = this.moment(this.derniereCloture, 'DD/MM/YYYY');
			var dateLeveeMoment = this.moment(this.inventaire.dateLevee, 'DD/MM/YYYY');
			if (dateClotureMoment.isValid() && dateLeveeMoment.isValid()) {
				if (dateLeveeMoment <= dateClotureMoment) {
					dateError = true;
					const error = this.$translate.instant('STOCKS.ERROR_DATE_CLOTURE') + dateClotureMoment.format('DD/MM/YYYY');
					this.inventaire.produits = null;
					this.isValidationDisabled = true;
					this.ongletOpen.isInventaireStocksOpen = false;
					this.notification.error(error);
				}
			}
		}
		if (!dateError) {
			this.loadInventaireStockProduits(
				this.inventaire.idGroupeSite,
				this.inventaire.eltNiv1,
				this.inventaire.idInventaire,
				this.inventaire.dateLevee,
				this.inventaire.isClotured
			);
		}
	}

	async checkDateCloture() {
		if (this.inventaire.idGroupeSite) {
			try {
				this.derniereCloture = await this.StocksCloturesService.getDerniereClotureMois(this.inventaire.idGroupeSite);
			} catch (ex) {
				this.derniereCloture = null;
			}
		} else {
			this.derniereCloture = null;
		}
	}

	async loadInventaireStockProduits(idGroupeSite, eltNiv1, idInventaire, date, isClotured) {
		this.startLoading();
		try {
			if (idGroupeSite && eltNiv1 && date) {
				this.inventaire.produits = await this.StocksService.getInventaireStockProduits(idGroupeSite, eltNiv1, idInventaire, date, isClotured);
				this.ongletOpen.isInventaireStocksOpen = true;

				if (this.inventaire.produits.lignes.length > 0) {
					this.isValidationDisabled = false;
				}
			}
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async initInventaire() {
		if (this.params && this.params.id) {
			this.startLoading();

			try {
				this.inventaire = {
					id: this.params.id
				};
				let inventaireStockForm = await this.StocksService.getInventaireById(this.inventaire.id);
				this.inventaire = new InventaireStockForm(inventaireStockForm);
			} catch (ex) {
				if (ex.status === 404) {
					this.goListInventaire();
				}
				this.notification.error(ex.data);
			} finally {
				this.stopLoading();
			}
		} else {
			this.inventaire = {};
			this.inventaire = new InventaireStockForm();
		}
	}

	openLevee(ligne) {
		var _this = this;
		_this.source = ligne;
		this.$uibModal
			.open({
				template: '<inventaire-stocks-levee levee="$ctrl.source" modal-instance="$ctrl.uibModalInstance"></inventaire-stocks-levee>',
				controller: [
					'$uibModalInstance',
					function ($uibModalInstance) {
						var $ctrl = this;
						$ctrl.source = _this.source;
						$ctrl.uibModalInstance = $uibModalInstance;
					}
				],
				controllerAs: '$ctrl',
				size: 'xxl',
				backdrop: false
			})
			.result.then(function (result) {
				if (result) {
					_this.getTotal();
				}
			});
	}

	getTotal() {
		let totalVolume = 0;
		let totalStock = 0;
		let totalEcart = 0;
		this.inventaire.produits.lignes.forEach(function (element) {
			totalVolume = totalVolume + element.volume;
			totalStock = totalStock + element.stockReleve;
			totalEcart = totalEcart + element.ecart;
		}, this);
		this.inventaire.produits.volumeTotal = totalVolume;
		this.inventaire.produits.stockReleveTotal = totalStock;
		this.inventaire.produits.ecartTotal = totalEcart;
	}

	async openMouvement() {
		this.updateInventaire();
		var _this = this;
		_this.source = this.inventaire;
		this.$uibModal
			.open({
				template:
					'<inventaire-stocks-mouvement inventaire="$ctrl.source" modal-instance="$ctrl.uibModalInstance"></inventaire-stocks-mouvement>',
				controller: [
					'$uibModalInstance',
					function ($uibModalInstance) {
						var $ctrl = this;
						$ctrl.source = _this.source;
						$ctrl.uibModalInstance = $uibModalInstance;
					}
				],
				controllerAs: '$ctrl',
				size: 'l',
				backdrop: false
			})
			.result.then(function (result) {
				if (result) _this.$state.go('stocks.inventaireedit', { id: _this.inventaire.idInventaire }, { reload: true });
			});
	}

	async createInventaire() {
		this.startLoading();
		try {
			let res = await this.StocksService.createInventaire(this.inventaire);
			this.notification.success('STOCKS.INVENTAIRELIG.CREATED');
			return res;
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async updateInventaire() {
		this.startLoading();
		try {
			let res = await this.StocksService.updateInventaire(this.inventaire);
			this.notification.success('STOCKS.INVENTAIRELIG.UPDATED');
			return res;
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async getEltsNiv1() {
		this.startLoading();
		try {
			this.listeEltsNiv1 = await this.StocksService.getElementsNiv1();
			this.inventaire.eltNiv1 = this.listeEltsNiv1[0].code;
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async confirmer() {
		if (!this.inventaire.libelle) {
			this.notification.error('STOCKS.NO_LIBELLE');
		} else if (this.isEditMode) {
			await this.updateInventaire();
		} else {
			const id = await this.createInventaire();

			if (id && this.inventaire.id) {
				this.reset();
			} else if (id) {
				this.$state.go('stocks.inventaireedit', { id: id });
			}
		}
	}

	async confirmerEtFermer() {
		if (!this.inventaire.libelle) {
			this.notification.error('STOCKS.NO_LIBELLE');
		} else if (this.isEditMode) {
			await this.updateInventaire();
			this.annuler();
		} else {
			let success = await this.createInventaire();

			if (success) {
				this.newInventaireId = success;
				this.annuler();
			}
		}
	}

	annuler() {
		this.backToPreviousState();
	}

	backToPreviousState() {
		this.$state.go('stocks.inventaire');
	}

	openFirstOnglet() {
		//par défaut, on ouvert l'onglet "Entête"
		this.ongletOpen = {
			isEnteteOpen: true
		};
	}

	closeAllOnglets() {
		this.ongletOpen = {
			isEnteteOpen: false,
			isInventaireStocksOpen: false,
			isInventaireStocksHistoriqueOpen: false
		};
	}

	async print() {
		this.startLoading();
		var fileName = Date.now();

		let resultat = await this.StocksService.printInventaireStock(
			this.inventaire.idGroupeSite,
			this.inventaire.eltNiv1,
			this.inventaire.idInventaire,
			this.inventaire.dateLevee
		);

		let data = resultat.data;
		let headers = resultat.headers;

		headers = headers();

		var contentType = headers['content-type'];

		let fileExtention = '.xlsx';
		var linkElement = document.createElement('a');
		try {
			var blob = new Blob([data], { type: contentType + ';charset=UTF-8' });
			var url = window.URL.createObjectURL(blob);
			linkElement.setAttribute('href', url);
			linkElement.setAttribute('download', fileName + fileExtention);

			var clickEvent = new MouseEvent('click', {
				view: window,
				bubbles: true,
				cancelable: false
			});
			linkElement.dispatchEvent(clickEvent);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	openImportodal() {
		const _this = this;
		const modalInstance = this.$uibModal.open({
			animation: true,
			size: 'md',
			backdrop: false,
			windowClass: 'modern-modal',
			template: `                
                <div class="modal-header modal-info mas-column mas-p-10" style="gap: 5px">
                    <div class="mas-col-fit">
                        <button type="button" class="close" aria-label="Close" ng-click="$ctrl.close()">
                            <span style="color: white" aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title"><span translate="STOCKS.CONFIRMATION_IMPORT_POPUP.TITLE"></span></h4>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="mas-col-fill">                          
                        <span translate="STOCKS.CONFIRMATION_IMPORT_POPUP.MESSAGE"></span>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="mas-col-fit">
                        <div class="mas-row mas-jc-fend">
                            <div class="mas-col-fit">                                
                                <button class="btn btn-primary" type="button" ng-click="$ctrl.validate()">
                                    <span ng-hide="$ctrl.isEdit" translate="STOCKS.IMPORT"></span>                      
                                </button>
                                <button class="btn btn-primary" type="button" ng-click="$ctrl.close()">
                                    <span class="massia-icon-door_exit"></span>
                                    <span class="hidden-xs" translate="FERMER"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>`,
			controllerAs: '$ctrl',
			controller: [
				'$uibModalInstance',
				function ($uibModalInstance) {
					this.validate = () => {
						$uibModalInstance.close();
					};
					this.close = () => $uibModalInstance.dismiss('cancel');
				}
			]
		});
		modalInstance.result.then(() => {
			_this.import();
		});
	}

	// Importer un fichier (déclenche l'interface de sélection de fichier)
	async import() {
		try {
			document.getElementById('file-upload').click();
		} catch (ex) {
			this.notification.error(ex?.data ?? 'An error occurred while importing the file');
		}
	}

	// Gérer le changement de fichier
	async change(event) {
		const files = event?.target?.files;
		if (!files?.length) return;

		const file = files[0];
		const formData = { file, inventaire: this.inventaire };

		try {
			const inventaireStockImport = await this.StocksService.import(formData);

			this.notification.success('STOCKS.INVENTAIRELIG.IMPORTED');
			this.inventaire.produits = {
				...this.updateTotauxStockLignes(inventaireStockImport),
				lignes: this.updateInventaireStockLignes(inventaireStockImport.lignes)
			};
		} catch (error) {
			console.error('Error processing file', error);
			this.notification.error(error?.data ?? 'An error occurred while importing the file');
		} finally {
			document.getElementById('file-upload').value = '';
		}
	}

	//on compare les totaux des lignes importées avec les totaux des lignes de l'inventaire
	updateTotauxStockLignes(inventaireStockImport) {
		if (inventaireStockImport.volumeTotal !== this.inventaire.produits.volumeTotal) {
			inventaireStockImport.isVolumeTotalModified = true;
		}
		if (inventaireStockImport.stockReleveTotal !== this.inventaire.produits.stockReleveTotal) {
			inventaireStockImport.isStockReleveTotalModified = true;
		}
		if (inventaireStockImport.stockTheoriqueTotal !== this.inventaire.produits.stockTheoriqueTotal) {
			inventaireStockImport.isStockTheoriqueTotalModified = true;
		}

		if (inventaireStockImport.ecartTotal !== this.inventaire.produits.ecartTotal) {
			inventaireStockImport.isEcartTotalModified = true;
		}
		return inventaireStockImport;
	}

	//on compare les lignes importées avec les lignes de l'inventaire
	updateInventaireStockLignes(importedLignes) {
		return importedLignes.map((ligne) => {
			const existingLigne = this.inventaire.produits.lignes.find((l) => l.idProduit === ligne.idProduit);

			if (existingLigne) {
				if (existingLigne.volume !== ligne.volume) {
					ligne.isVolumeModified = true;
				} else {
					ligne.isVolumeModified = false;
				}

				if (existingLigne.remarques !== ligne.remarques && ligne.remarques !== '' && ligne.remarques !== null) {
					ligne.isRemarquesModified = true;
				} else {
					ligne.isRemarquesModified = false;
				}
			}
			return ligne;
		});
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
